var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGadgets = function SvgGadgets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "gadgets_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#gadgets_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gadgets_svg__b",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gadgets_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#13CFE8",
    d: "M10 5.833q-.522 0-.886-.364a1.2 1.2 0 0 1-.364-.886q0-.52.364-.885T10 3.333t.885.365.365.885-.365.886a1.2 1.2 0 0 1-.885.364m0 13.334q-1.73 0-2.948-1.219Q5.832 16.73 5.833 15V5q0-1.729 1.219-2.948Q8.27.833 10 .833q1.728 0 2.948 1.22Q14.166 3.27 14.166 5v10q0 1.73-1.218 2.948-1.22 1.22-2.948 1.219m0-12.5q.874 0 1.479-.604.604-.604.604-1.48 0-.875-.604-1.479a2 2 0 0 0-1.48-.604q-.875 0-1.478.604a2.01 2.01 0 0 0-.605 1.48q0 .874.605 1.479.603.604 1.479.604M10 17.5a2.4 2.4 0 0 0 1.77-.73q.73-.727.73-1.77V7.354a3.66 3.66 0 0 1-2.5.98q-.688 0-1.334-.25T7.5 7.353V15q0 1.042.729 1.77a2.4 2.4 0 0 0 1.77.73m-1.25-4.167q.354 0 .593-.24.24-.239.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.594t.594.24m0-2.5q.354 0 .593-.24.24-.239.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.594t.594.24m2.5 0q.354 0 .593-.24.24-.239.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.594t.594.24m0 2.5q.354 0 .593-.24.24-.239.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.594t.594.24m-2.5 2.5q.354 0 .593-.24.24-.239.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.594t.594.24m2.5 0q.354 0 .593-.24.24-.239.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.594t.594.24"
  })))));
};
export default SvgGadgets;